import React from 'react';
import { Card, CardContent, Typography, Box, Avatar, LinearProgress, IconButton, Skeleton, Tooltip } from '@mui/material';
import { MoreVert as MoreVertIcon } from '@mui/icons-material';

const getProgressColor = (percentage) => {
	if (percentage < 30) {
		return 'error';
	}
	if (percentage < 70) {
		return 'warning';
	}
	return 'success';
};

const getInitials = (name = '') => {
	const nameParts = name.trim().split(' ');
	if (nameParts.length > 1) {
		return `${nameParts[0][0]}${nameParts[nameParts.length - 1][0]}`.toUpperCase();
	}
	return name.substring(0, 2).toUpperCase();
};

const TopSalesManagersWidgetComponent = ({ details, isLoading }) => {
	return (
		<Card sx={{ borderRadius: 3, boxShadow: '0 4px 12px rgb(0 0 0 / 0.05)', height: '280px' }}>
			<CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
				{/* Header */}
				<Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
					<div className="text-lg fw-500">Sales Team - Monthly Sales</div>
					{/*<Tooltip title="More options">*/}
					{/*	<IconButton size="small">*/}
					{/*		<MoreVertIcon />*/}
					{/*	</IconButton>*/}
					{/*</Tooltip>*/}
				</Box>

				<Box
					className="custom-scrollbar"
					sx={{
						flexGrow: 1,
						overflowY: 'auto',
						pr: 1
					}}
				>
					{isLoading ? (
						[...Array(5)].map((_, index) => (
							<Box key={index} display="flex" alignItems="center" sx={{ mb: 2.5 }}>
								<Skeleton variant="circular" width={40} height={40} />
								<Box flex={1} ml={2}>
									<Skeleton variant="text" width="60%" height={20} />
									<Skeleton variant="rounded" width="100%" height={10} sx={{ mt: 0.5 }} />
								</Box>
								<Skeleton variant="text" width="15%" height={25} sx={{ ml: 2 }} />
							</Box>
						))
					) : details && details.length > 0 ? (
						details.map((manager) => {
							const progressColor = getProgressColor(manager.percentage);
							return (
								<Box key={manager.name} display="flex" alignItems="center" sx={{ mb: 2.5 }}>
									<Avatar src={manager.profile_photo_url} sx={{ bgcolor: 'primary.main', width: 40, height: 40 }}>
										{getInitials(manager.name)}
									</Avatar>
									<Box flex={1} ml={2}>
										<div className="font-normal" style={{ width: '55%' }}>
											{manager.name}
										</div>
										<LinearProgress
											variant="determinate"
											value={manager.percentage}
											color={progressColor}
											sx={{ height: 7, borderRadius: '5px', mt: 0.5 }}
										/>
									</Box>
									<Typography variant="subtitle1" fontWeight="600" color={`${progressColor}.main`} ml={2} width="45px" textAlign="right">
										{`${(manager.percentage < 0 ? 0 : Math.round(manager.percentage)).toFixed(2)}%`}
									</Typography>
								</Box>
							);
						})
					) : (
						<Typography variant="body2" color="text.secondary" textAlign="center" py={3}>
							No sales team data available.
						</Typography>
					)}
				</Box>
			</CardContent>
		</Card>
	);
};

export default TopSalesManagersWidgetComponent;